import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shield"
const ShieldIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.486 3.021A1 1 0 0 1 21 3.879v5.819c0 8.818-8.183 13.022-8.531 13.196l-.448.225-.447-.224C11.224 22.721 3 18.518 3 9.698V3.879a1 1 0 0 1 1.511-.86c3.357 1.994 6.736-1.654 6.77-1.691A.997.997 0 0 1 12.02 1h.007a1 1 0 0 1 .742.337c.134.15 3.367 3.696 6.717 1.684Zm-7.782 4.775c.261.26.261.684 0 .945l-3.463 3.463a.668.668 0 0 1-.945-.945l3.463-3.463c.261-.261.684-.261.945 0Zm4.248.209a.7.7 0 0 0-.99 0l-6.457 6.457a.7.7 0 1 0 .99.99l6.457-6.457a.7.7 0 0 0 0-.99Zm.752 4.736a.668.668 0 0 0-.945-.945l-3.463 3.463a.668.668 0 1 0 .945.945l3.463-3.463Z"
      />
    </svg>
  )
}
export default ShieldIcon
